export const assetsPATHS = {
  webLogo: "/assets/web_logo.svg",
  artist: "/assets/artist.png",
};
